export default __webpack_public_path__ + "static/media/ecosense-brandmark-positive.246c4d19.png";